import * as files from '../xhr/files.js';
import * as notifier from "./notifier.js";
import * as loader from './loader.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(type = 'full', dispatch, isLoading) {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @param type
 * @param id
 * @param parentFolder
 * @param path
 * @returns {function(*): *}
 */
export function listFiles(type, id, parentFolder, path = null) {
    return (dispatch) => {
        setLoader(type, dispatch, true);

        return files.listFiles(type, id, parentFolder, path)
            .then((data) => {
                setLoader(type, dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(type, dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param type
 * @param id
 * @param parentFolder
 * @param folderName
 * @param path
 * @returns {function(*): *}
 */
export function createFolder(type, id, parentFolder, folderName, path = null) {
    return (dispatch) => {
        setLoader(type, dispatch, true);

        return files.createFolder(type, id, parentFolder, folderName, path)
            .then(() => {
                setLoader(type, dispatch, false);
                return true;
            })
            .catch((error) => {
                setLoader(type, dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param type
 * @param id
 * @param parentFolder
 * @param file
 * @param path
 * @returns {function(*): Promise<boolean>}
 */
export function uploadFile(type, id, parentFolder, file, path = null) {
    return (dispatch) => {
        setLoader(type, dispatch, true);

        return files.uploadFile(type, id, parentFolder, file, path)
            .then(() => {
                setLoader(type, dispatch, false);
                return true;
            })
            .catch((error) => {
                setLoader(type, dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param type
 * @param id
 * @param parentFolder
 * @param path
 * @returns {function(*): *}
 */
export function downloadFile(type, id, parentFolder, path) {
    return (dispatch) => {
        setLoader(type, dispatch, true);

        return files.downloadFile(type, id, parentFolder, path)
            .then((url) => {
                setLoader(type, dispatch, false);
                return url;
            })
            .catch((error) => {
                setLoader(type, dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param type
 * @param id
 * @param parentFolder
 * @param path
 * @returns {(function(*): (*|undefined))|*}
 */
export function removeFile(type, id, parentFolder, path) {
    return (dispatch) => {
        setLoader(type, dispatch, true);

        return files.removeFile(type, id, parentFolder, path)
            .then(() => {
                setLoader(type, dispatch, false);
                return true;
            })
            .catch((error) => {
                setLoader(type, dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param type
 * @param id
 * @param path
 * @returns {function(*): Promise<boolean>}
 */
export function makePrivate(type, id, path) {
    return (dispatch) => {
        setLoader(type, dispatch, true);

        return files.makePrivate(type, id, path)
            .then(() => {
                setLoader(type, dispatch, false);
                return true;
            })
            .catch((error) => {
                setLoader(type, dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param type
 * @param id
 * @param path
 * @returns {function(*): Promise<boolean>}
 */
export function makePublic(type, id, path) {
    return (dispatch) => {
        setLoader(type, dispatch, true);

        return files.makePublic(type, id, path)
            .then(() => {
                setLoader(type, dispatch, false);
                return true;
            })
            .catch((error) => {
                setLoader(type, dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}